// The saved-targets sheet: bookmarks and recent targets from bookmarks/list, shared by the Rally Point and the Market.
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { IconBookmark, IconSwords } from "@/kit/icons";
import { Sheet } from "@/kit/overlays";
import { Empty, Row, RowText } from "@/kit/primitives";
import { fmtCoords } from "@/game/format";
import { useCity } from "./CityRoute";

export const bookmarkList = (arr: Record<string, string>[] | undefined) => (arr ?? []).flatMap((o) => Object.entries(o).map(([name, coords]) => ({ name, coords })));

export function useBookmarks(enabled = true) {
  const { wid } = useCity();
  return useQuery({ queryKey: ["bookmarks", wid], queryFn: () => api.bookmarks.list({ wid }), enabled, staleTime: 60_000 });
}

export function SavedTargets({ open, onClose, onPick }: { open: boolean; onClose: () => void; onPick: (coords: string) => void }) {
  const q = useBookmarks(open);
  const saved = bookmarkList(q.data?.bookmarks);
  const recent = bookmarkList(q.data?.recent_bookmarks);
  return (
    <Sheet open={open} onClose={onClose} label="Saved targets" title={<h3 className="eyebrow" style={{ margin: "0 0 14px" }}>Saved targets</h3>}>
      {q.isLoading && <Empty><span className="spin" /> Reading bookmarks…</Empty>}
      {!q.isLoading && !saved.length && !recent.length && <Empty>No bookmarks yet. Bookmark cities from the map.</Empty>}
      {saved.length > 0 && <div className="c-section">Bookmarks</div>}
      <div className="rows">{saved.map((b, i) => <Row key={`s${i}`} as="button" onClick={() => onPick(b.coords)}><IconBookmark style={{ width: 18, height: 18, color: "var(--g-text)" }} /><RowText line={b.name} meta={fmtCoords(b.coords)} /></Row>)}</div>
      {recent.length > 0 && <div className="c-section" style={{ marginTop: 14 }}>Recent</div>}
      <div className="rows">{recent.map((b, i) => <Row key={`r${i}`} as="button" onClick={() => onPick(b.coords)}><IconSwords style={{ width: 18, height: 18, color: "var(--g-text)" }} /><RowText line={b.name} meta={fmtCoords(b.coords)} /></Row>)}</div>
    </Sheet>
  );
}

